import React from 'react';
import './PrivacyPolicy.css';
import SEOHead from '../SEOHead';

const PrivacyPolicy: React.FC = () => {
  // Immediate scroll to top on component render
  React.useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <div className="privacy-policy">
      <SEOHead
        title="Privacy Policy"
        description="Read Antaryatra's Privacy Policy to understand how we collect, use and protect your personal data when you book puja ceremonies through our platform."
        canonicalPath="/privacy-policy"
        noIndex={false}
      />
      <div className="container">
        <div className="legal-content">
          <h1>Privacy Policy</h1>
          <div className="last-updated">
            Last updated: January 10, 2026
          </div>

          <section>
            <h2>1. Information We Collect</h2>
            <p>
              We collect information you provide directly to us, such as when you create an account, 
              book services, make payments, or contact us. This includes:
            </p>
            <ul>
              <li>Personal identification information (name, email address, phone number)</li>
              <li>Payment information (processed securely through third-party processors)</li>
              <li>Service preferences and booking history</li>
              <li>Communications with our support team</li>
            </ul>
          </section>

          <section>
            <h2>2. How We Use Your Information</h2>
            <p>We use the information we collect to:</p>
            <ul>
              <li>Provide, maintain, and improve our services</li>
              <li>Process transactions and send confirmations</li>
              <li>Send you technical notices, updates, security alerts</li>
              <li>Respond to your comments, questions, and requests</li>
              <li>Personalize and improve your experience</li>
              <li>Monitor and analyze trends, usage, and activities</li>
            </ul>
          </section>

          <section>
            <h2>3. Information Sharing and Disclosure</h2>
            <p>
              We may share your information in the following situations:
            </p>
            <ul>
              <li><strong>Service Providers:</strong> With trusted third-party service providers who assist us in operating our platform</li>
              <li><strong>Legal Requirements:</strong> When required by law or to protect our rights and safety</li>
              <li><strong>Business Transfers:</strong> In connection with any merger, sale of assets, or acquisition</li>
              <li><strong>With Your Consent:</strong> When you explicitly consent to sharing your information</li>
            </ul>
          </section>

          <section>
            <h2>4. Data Security</h2>
            <p>
              We implement appropriate security measures to protect your personal information against 
              unauthorized access, alteration, disclosure, or destruction. However, no method of 
              transmission over the internet is 100% secure.
            </p>
          </section>

          <section>
            <h2>5. Data Retention</h2>
            <p>
              We retain your personal information only for as long as necessary to fulfill the purposes 
              outlined in this privacy policy, unless a longer retention period is required or permitted by law.
            </p>
          </section>

          <section>
            <h2>6. Your Rights</h2>
            <p>You have the right to:</p>
            <ul>
              <li>Access, update, or delete your personal information</li>
              <li>Opt out of certain communications</li>
              <li>Request a copy of your data</li>
              <li>Object to processing of your personal information</li>
            </ul>
          </section>

          <section>
            <h2>7. Cookies and Tracking Technologies</h2>
            <p>
              We use cookies and similar tracking technologies to collect and use personal information about you. 
              You can control cookies through your browser settings.
            </p>
          </section>

          <section>
            <h2>8. Third-Party Links</h2>
            <p>
              Our service may contain links to third-party websites. We are not responsible for the privacy 
              practices or content of these third-party sites.
            </p>
          </section>

          <section>
            <h2>9. Changes to This Privacy Policy</h2>
            <p>
              We may update this privacy policy from time to time. We will notify you of any changes by 
              posting the new privacy policy on this page and updating the "Last updated" date.
            </p>
          </section>

          <section>
            <h2>10. Contact Us</h2>
            <p>
              If you have any questions about this privacy policy, please contact us at:
            </p>
            <div className="contact-info">
              <p><strong>Email:</strong> communication@antaryatra.org</p>
              {/* <p><strong>Phone:</strong> +91 XXXXX XXXXX</p> */}
              <p><strong>Address:</strong> N6/2B-124, Indira Nagar, Chitaipur, Varanasi, Uttar Pradesh - 221005, India</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;